import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateFlyerElement } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { FLYER_DATA } from '../../../constants/state'
import EditElement from '../present/EditElement'
import { GRID_IMAGE, IMAGE, METRO, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'

const mapStateToProps = (state, ownProps) => ({
    flyersServerData: getData(state, FLYER_DATA)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData,  elementType, flyerPk) => {
        dispatch(updateFlyerElement(elementType, itemData, flyerPk))
    }
})

const EditElementContainer = ({flyersServerData, onUpdateItem, itemType, closePagePath, printPk, itemId}) => {
    let itemData

    if(!flyersServerData || !flyersServerData.flyers) {
        return ''
    }

    const currentFlyer = flyersServerData.flyers[printPk]

    
    if(itemType === IMAGE) {
        itemData = flyersServerData.imageElements.items[itemId]
    } else if (itemType === TEXT) {
        itemData = flyersServerData.textElements.items[itemId]
    } else if (itemType === TITLE) {
        itemData = flyersServerData.headlineElements.items[itemId]
    } else if(itemType === METRO) {
        itemData = flyersServerData.metroElements.items[itemId]
    } else if(itemType === MOVIE_PERFORMANCES)  {
        itemData = currentFlyer.moviePerformances.items[itemId]
    } else if(itemType === GRID_IMAGE) {
        itemData = currentFlyer.gridImages.items[itemId]
    }
        
    
    if(!itemData) {
        return ''
    }

    return <EditElement
        itemData={itemData}
        closePagePath={closePagePath}
        flyerPk={printPk}
        onUpdateItem={onUpdateItem}
        itemType={itemType}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditElementContainer)